import barba from '@barba/core';
import 'lazysizes'; // doesn’t require a function call
//import LocomotiveScroll from 'locomotive-scroll';
import menu from './menu';
import video from './video';
import progress from './progress';
import header from './header';
import { animationEnter, animationLeave } from './animations';
//import preload from './preload';
import rellax from 'rellax';
import ScrollOut from "scroll-out";

// set locomotive scroll
//let scroll;
let scrollX = 0
let scrollY = 0

// Before the page loads
barba.hooks.beforeOnce(() => {
  console.log('beforeOnce');
  video();
  menu();
  backTop();
  moveDown();
  header();
  rellax();

  // const home = document.querySelector('.tmpl-home');
  // // //If post isn't "undefined" and isn't "null", then run function.
  // if (typeof(home) != 'undefined' && home != null){
  //   quote();
  // }

  ScrollOut({
    /* options */
    //targets: '[data-scroll], [data-splitting]',
    threshold: .2
  })
  //preload();

  const post = document.querySelector('.tmpl-post');
  // //If post isn't "undefined" and isn't "null", then run function.
  if (typeof(post) != 'undefined' && post != null){
    progress();
  }
})

barba.hooks.beforeLeave(() => {
  //console.log('beforeleave');
  //const main = document.querySelector('#main-content');
  //main.style.opacity = "0";
  setTimeout(function(){ 
    // reset scroll position to top of page after half a second
    //scroll.setScroll(0,0);
    //scroll.scrollTo(0,0);
    window.scrollTo(0,0);
  }, 500);
})

// Right after the leave transition, do this
barba.hooks.leave(() => {
  //console.log('leave');
  // See: https://barba.js.org/docs/advanced/recipes/#Scroll-position
  // if (history.scrollRestoration) {
  //   history.scrollRestoration = 'manual';
  // }
  scrollX = barba.history.current.scroll.x;
  scrollY = barba.history.current.scroll.y;
  window.scrollTo(scrollX, scrollY);
  // destroy scroll instance
  //scroll.destroy();
})

// barba.hooks.beforeEnter(() => {
//     // destroy scroll instance
//     scroll.destroy();
//     // initialize scroll instance
//     scroll.init();
// })

// After all transitions, do this
barba.hooks.after(() => {
  console.log('after');
  video();
  menu();
  backTop();
  moveDown();
  header();
  rellax();

  // const home = document.querySelector('.tmpl-home');
  // // //If post isn't "undefined" and isn't "null", then run function.
  // if (typeof(home) != 'undefined' && home != null){
  //   quote();
  // }

  ScrollOut({
    /* options */
    threshold: .2
  })
  // update locomotive scroll
  //scroll.update();

  const post = document.querySelector('.tmpl-post');
  // //If post isn't "undefined" and isn't "null", then run function.
  if (typeof(post) != 'undefined' && post != null){
    progress();
  }

  // send a pageview to Google Analytics
  // https://barba.js.org/docs/advanced/third-party/#analytics-js
  ga('set', 'page', window.location.pathname);
  ga('send', 'pageview');

});

// Initilize barba.js
barba.init({
  transitions: [
    {
      once({next}){
        animationEnter(next.container);
        //smooth();
      },
      leave: ({current}) => animationLeave(current.container),
      enter({next}){
        // initialize scroll instance
        //scroll.init();
         // Enable if using locomotive scroll
        //scroll.update();
        //console.log('entering');
        animationEnter(next.container);
      }
    }
  ]
})

 // Enable if using locomotive scroll
// function smooth() {
// 	scroll = new LocomotiveScroll({
// 		el: document.querySelector('[data-scroll-container]'),
// 		smooth: true,
//     lerp: 0.1
// 	});
// }

function backTop() {
  const backToTop = document.querySelector('#backToTop');
  backToTop.addEventListener('click', (e) => {
    //console.log(e);
    // Enable if using locomotive scroll
    //scroll.scrollTo(0, 0);
    // Disable if using locomotive scroll
    window.scrollTo(0, 0);
  });
}

function moveDown() {
  // move down button
  const home = document.querySelector('.tmpl-home');
  //If post isn't "undefined" and isn't "null", then run function.
  if (typeof(home) != 'undefined' && home != null){
    const moveDown = document.querySelector('#moveDown');
    moveDown.addEventListener('click', (e) => {
      console.log(e);
      // Enable if using locomotive scroll
      //scroll.scrollTo(760, 0);
      // Disable if using locomotive scroll
      window.scrollTo(0, 760);
    });
  }
}

// function progress() {
//   // see: https://www.digitalocean.com/community/tutorials/js-progress-bar-javascript-css-variables
//   gsap.from(".progress", {
//     scrollTrigger: {
//       trigger: ".progress",
//       scroller: "[data-scroll-container]",
//       scrub: true,
//       start: "top top",
//       end: "top top",
//       onUpdate: self => console.log(self.direction)
//     },
//     scaleX: 0,
//     transformOrigin: "left center", 
//     ease: "none"
//   });  
//}


// function responsive() {
//   // init function if window is larger than mobile device
//   if (window.innerWidth > 760) {
//     // do something
//   }
// }

// window.addEventListener('load', (event) => {
//   init stuff
// });